import { Box, Stack, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { INavigationItem } from "../../../models/navigation";
import Cards from "../Cards";
import { useAppSelector } from "../../../store/store";
import { tokenTemporaryService } from "../../../services/tokenTemorary.service";

const NavigatorCard: FC<INavigationItem> = ({
  icon,
  link,
  name,
  onClick,
  cardValidatorLink,
}) => {
  const navigate = useNavigate();

  const theme = useTheme();

  const { actions } = useAppSelector((state) => state.theme);

  const { individual } = useAppSelector((state) => state.user);

  const { t } = useTranslation();

  const isLogginTemporary = tokenTemporaryService.hasTemporaryAccessToken();

  const onClickHandler = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate(link);
  };

  const isDoctor = individual.profiles.find((p) => p.code === "7");

  const effectiveLink = cardValidatorLink || link;
  const action = actions ? actions.find((a) => a.link === effectiveLink) : null;

  if (!isDoctor && link === "/doctor-agenda") {
    return null;
  }

  if (
    (!isDoctor &&
      cardValidatorLink &&
      cardValidatorLink === "/medical-transfer") ||
    (isLogginTemporary && cardValidatorLink !== "/exams")
  ) {
    return null;
  }

  return (
    <Stack
      width={120}
      minWidth={120}
      onClick={onClickHandler}
      sx={(theme) => ({
        cursor: "pointer",
        "&:hover": {
          color: theme.palette.primary.main,
        },
      })}
    >
      <Cards
        width={"100%"}
        sx={{
          backgroundColor:
            action && action.iconBackgroundColor
              ? action.iconBackgroundColor === "primary"
                ? theme.palette.primary.main
                : action.iconBackgroundColor
              : undefined,
        }}
      >
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          direction={"column"}
          sx={{
            height: "90px",
            width: "100%",
          }}
        >
          <Box>{icon}</Box>
        </Stack>
      </Cards>
      <Typography textAlign={"center"} flexWrap={"wrap"} width={"100%"} mt={1}>
        {t(name)}
      </Typography>
    </Stack>
  );
};

export default NavigatorCard;
